import React from 'react';
import { Compass, Heart, MessageCircle, User } from 'lucide-react';
import { motion } from 'framer-motion';
type Tab = 'discover' | 'matches' | 'messages' | 'profile';
interface BottomNavProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  unreadMatches?: number;
  unreadMessages?: number;
}
export function BottomNav({
  activeTab,
  onTabChange,
  unreadMatches = 0,
  unreadMessages = 0
}: BottomNavProps) {
  const tabs = [{
    id: 'discover',
    icon: Compass,
    label: 'Discover'
  }, {
    id: 'matches',
    icon: Heart,
    label: 'Matches',
    badge: unreadMatches
  }, {
    id: 'messages',
    icon: MessageCircle,
    label: 'Messages',
    badge: unreadMessages
  }, {
    id: 'profile',
    icon: User,
    label: 'Profile'
  }] as const;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-zinc-100 pb-safe pt-2 px-6 z-50" data-id="element-71">
      <div className="flex justify-between items-center max-w-md mx-auto h-16" data-id="element-72">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className="relative flex flex-col items-center justify-center w-12 h-12" aria-label={tab.label} data-id="element-73">
              <div className="relative" data-id="element-74">
                <Icon size={28} className={`transition-colors duration-300 ${isActive ? 'text-rose-500 fill-rose-500/10' : 'text-zinc-400'}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-75" />
                {tab.badge ? <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-rose-500 text-[10px] font-bold text-white ring-2 ring-white" data-id="element-76">
                    {tab.badge}
                  </span> : null}
              </div>
              {isActive && <motion.div layoutId="nav-indicator" className="absolute -bottom-2 w-1 h-1 bg-rose-500 rounded-full" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-77" />}
            </button>;
      })}
      </div>
    </div>;
}